import { isReferral } from "../../TransactionDetailsPage/shared/helpers";

export const STATUSES = [
  "pipeline",
  "comingsoon",
  "active",
  "pending",
  "sold",
  "expired",
  "withdrawn",
  "canceled",
  "archived",
];

export const isCustomTitle = (type, useCustomTitle) => isReferral(type) || useCustomTitle;
